// extracted by mini-css-extract-plugin
export default {"flag-image":"LanguageSelection_flag-image__rIVnZ","language-text":"LanguageSelection_language-text__rsvgI"};